import { BrowserModule } from '@angular/platform-browser';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { TalkingPointTextEditModalModule } from 'Angular/features/components/modals/talking-point-text-edit-modal/talking-point-text-edit-modal.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import * as i0 from "@angular/core";
export class TalkingPointsMultiSelectSavedModalModule {
}
TalkingPointsMultiSelectSavedModalModule.ɵfac = function TalkingPointsMultiSelectSavedModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsMultiSelectSavedModalModule)(); };
TalkingPointsMultiSelectSavedModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TalkingPointsMultiSelectSavedModalModule });
TalkingPointsMultiSelectSavedModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        FoldersSharedModule,
        IconModule,
        DisabledModule,
        TooltipModule,
        GetOwnerDisplayNamePipeModule,
        SimpleDropdownModule,
        TalkingPointTextEditModalModule] });
